<template>
  <el-drawer
    v-if="visible"
    :visible="visible"
    :title="title"
    show-close
    size="1000px"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    :modal-append-to-body="false"
  >
    <div class="ml-4 mr-4">
      <Main
        ref="main"
        @reload="$emit('reload')"
        @close="close()"
        :invSkuSetCode="invSkuSetCode"
        :disabled="disabled"
      />
      <div class="mt-2 mb-4 d-flex justify-content-end" v-if="!disabled">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    invSkuSetCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
